import React from 'react'
import { SmlsButton, SmlsModal } from "@smiles/smiles-ui-kit-react";
import { ModalBody } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { getLink } from '../../utils';
import { useFirstAccessModal } from '../../context/FirstAccessModalContext';

export function FirstAccessModal() {
  const { firstAccessModal } = useFirstAccessModal()
  const { t } = useTranslation("first_access_modal")

  function handlePrimaryButtonClick() {
    const recoverPasswordUrl = getLink('recuperar/senha')
    window.location.href = recoverPasswordUrl
  }

  function handleSecondaryButtonClick() {
    firstAccessModal.closeModal();
  }

  return (
    <SmlsModal
      isOpen={firstAccessModal.isModalOpen}
      type='right'
      toggle={firstAccessModal.toggleModal}
      onExit={firstAccessModal.closeModal}
    >
      <ModalBody className="smls-modal-body modal-first-access-container">
        <div className="smls-modal-header modal-first-access-header">
          <h4>{t('title.line_0')}</h4>
          <h4>{t('title.line_1')}</h4>
        </div>

        <div className="smls-modal-text modal-first-access-content">
          <p className='modal-first-access-introduction'>{t('text_content.introduction')}</p>
          <ul className='modal-first-access-list'>
            <li>{t('text_content.list.item_0')}</li>
            <li>{t('text_content.list.item_1')}</li>
          </ul>
          <p className='modal-first-access-conclusion'>{t('text_content.conclusion')}</p>
        </div>

        <SmlsButton
          text={t('create_or_recover_button')}
          className='modal-first-access-button-primary'
          onClick={handlePrimaryButtonClick}
        />

        <SmlsButton
          text={t('already_has_password_button')}
          className='modal-first-access-button-secondary'
          color='secondary'
          onClick={handleSecondaryButtonClick}
        />
      </ModalBody>
    </SmlsModal>
  )
}

